<template>
  <!-- <div> -->
  <pre-register-form />
  <!-- </div> -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import PreRegisterForm from "../components/PreRegisterForm.vue";

export default {
  name: "Home",
  components: {
    PreRegisterForm,
  },
};
</script>
